import React, { useState, useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Select from "../components/Select";
import Api from "../utils/Api";
import { Button, Form } from "react-bootstrap";
import Datetime from "react-datetime";
import Notifier from "../components/Notifier";

const transactionTypes = [
    { id: 1, description: "הוצאה" },
    { id: 2, description: "הכנסה" }
];

export default function AddTransaction() {
    const [tagLookup, setTagLookup] = useState(null);
    const [categoryLookup, setCategoryLookup] = useState(null);
    const [time, setTime] = useState(new Date());
    const [description, setDescription] = useState(null);
    const [remarks, setRemarks] = useState(null);
    const [amount, setAmount] = useState(null);
    const [categoryId, setCategoryId] = useState(null);
    const [transactionType, setTransactionType] = useState(1); // Default to הוצאה
    const [tags, setTags] = useState(null);

    const notifierInstance = useRef(null);

    useEffect(async () => {
        const { response: lookups } = await Api.lookups();
        setTagLookup(lookups.tags);
        setCategoryLookup(lookups.categories);
    }, []);

    const cardStyle = {
        background: "white",
        margin: "30px",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px"
    };

    const handleTimeChange = (time) => {
        setTime(time);
    };

    const handleDescriptionChange = (description) => {
        setDescription(description.target.value);
    };

    const handleAmountChange = (amount) => {
        setAmount(amount.target.value);
    };

    const handleRemarksChange = (remarks) => {
        setRemarks(remarks.target.value);
    };

    const save = async () => {
        const missingFields = [];
        if (!time) missingFields.push("תאריך");
        if (!transactionType) missingFields.push("סוג פעולה");
        if (!categoryId) missingFields.push("קטגוריה");
        if (!amount) missingFields.push("סכום");

        if (missingFields.length > 0) {
            notifierInstance.current?.showError(`יש למלא את השדות הבאים: ${missingFields.join(", ")}`);
            return;
        }
        const data = {
            time,
            categoryId,
            tags,
            description: description || "הוזן ידנית",
            remarks,
            amount,
            transactionType: transactionType === 1 ? "debt" : "credit"
        };
        const { response, status } = await Api.post("/api/addTransaction", data);

        if (status === 200) {
            notifierInstance.current?.showSuccess("נשמר בהצלחה");
            resetForm();
        } else {
            notifierInstance.current?.showError("שגיאה בשמירה");
        }
    };

    const resetForm = () => {
        setTime(new Date());
        setDescription("");
        setRemarks("");
        setAmount(0);
        setCategoryId(null);
        setTransactionType(1); // Reset to default הוצאה
        setTags(null);
    };

    const handleCategoryChanged = (changed) => {
        setCategoryId(changed);
    };

    const handleTransactionTypeChanged = (transactionType) => {
        setTransactionType(transactionType);
    };

    const handleTagChanged = (changed) => {
        setTags(changed);
    };

    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                justifyContent: "center"
            }}
        >
            <div style={cardStyle}>
                <div style={{ margin: "20px" }}>
                    <div>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>תאריך</Form.Label>
                            <Datetime
                                locale="he"
                                dateFormat={"DD-MM-YYYY"}
                                timeFormat={false}
                                closeOnSelect={true}
                                value={time}
                                onChange={handleTimeChange}
                            />
                        </Form.Group>

                        <Form.Group style={{ width: "280px" }} className="mb-3" controlId="formBasicEmail">
                            <Form.Label>תיאור</Form.Label>
                            <Form.Control
                                value={description}
                                type="email"
                                placeholder="תיאור"
                                onChange={handleDescriptionChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>סוג פעולה</Form.Label>
                            <div style={{ width: "150px" }}>
                                <Select
                                    options={transactionTypes}
                                    multi={false}
                                    style={{ width: "150px" }}
                                    onSelect={handleTransactionTypeChanged}
                                    selected={transactionType}
                                    placeholder="סוג פעולה"
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>קטגוריה</Form.Label>
                            {categoryLookup ? (
                                <div style={{ width: "280px" }}>
                                    <Select
                                        options={categoryLookup}
                                        multi={false}
                                        style={{ width: "200px" }}
                                        onSelect={handleCategoryChanged}
                                        selected={categoryId}
                                        placeholder="קטגוריה"
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>תגיות</Form.Label>
                            {tagLookup ? (
                                <div style={{ width: "280px" }}>
                                    <Select
                                        options={tagLookup}
                                        multi={true}
                                        onSelect={handleTagChanged}
                                        closeOnSelect={false}
                                        selected={tags}
                                        placeholder="תגיות"
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>סכום</Form.Label>
                            <Form.Control
                                value={amount}
                                type="email"
                                placeholder="סכום"
                                onChange={handleAmountChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>הערות</Form.Label>
                            <Form.Control
                                value={remarks}
                                type="email"
                                placeholder="הערות"
                                onChange={handleRemarksChange}
                            />
                        </Form.Group>

                        <Button
                            style={{
                                background: "rgb(255, 102, 102)",
                                borderRadius: "17px",
                                borderColor: "rgb(255, 102, 102)"
                            }}
                            variant="primary"
                            type="submit"
                            onClick={save}
                        >
                            שמור
                        </Button>
                    </div>
                </div>
            </div>
            <Notifier ref={notifierInstance} />
        </div>
    );
}
